import { SWRConfiguration } from "swr";
import useSWR from "@/hooks/useSWR";
import { getToken } from "@/security/authentication";

import { ProfileType } from "../types";

export default function useProfile(
  enable = true,
  swrOptions?: SWRConfiguration
) {
  const sessionToken = getToken();

  const {
    data: profile,
    mutate: mutateProfile,
    error: profileError,
    isLoading: isProfileLoading,
    isValidating: isProfileValidating,
  } = useSWR<ProfileType>(
    {
      url: "/profile/",
      enabled: enable && !!sessionToken,
    },
    swrOptions
  );

  return {
    mutateProfile,
    profile,
    profileError,
    isProfileLoading,
    isProfileValidating,
  };
}
